import React, { useState, useEffect } from 'react'
import SimpleModal from 'components/Modal/SimpleModal'
import { Steps, Form, message } from 'antd'
import CareNeeds from './components/careNeeds'
import PatientInformation from './components/patientInformation'
import { DataGetAction, DataRequestAction } from 'redux/actions/http'
import { useDispatch, useSelector } from 'react-redux'
import HealthCondition from './components/HealthCondition'
import Information from './components/Information'
const { Step } = Steps;
const Index = () => {




    const surveyProps = useSelector(state => state.surveyR)
    const { savingFirstSurvey, surveySaveSuccess, surveySaveError } = surveyProps
    const dispatch = useDispatch();


    // const dispatch = useDispatch()
    const signupProps = useSelector(state => state.signUp)
    const { multiStepModelVisible, questionsList } = signupProps
    const [current, setCurrent] = useState(0);
    const [formData, setFormData] = useState({})
    const [form] = Form.useForm();

    console.log('========formData============', formData)

    const fetchQuestions = () => {
        dispatch(DataGetAction('getPatientQuestion', '', 'gettingPatientQuestion'));
    }

    useEffect(fetchQuestions, []);

    const next = (data, key) => {
        const formObj = formData
        formObj[key] = data
        setFormData({ ...formObj })
        setCurrent(current + 1);
    };

    // const prev = () => {
    //     setCurrent(current - 1);
    // };

    const completed = (data, key) => {
        const formObj = formData
        formObj[key] = data
        dispatch(DataRequestAction('POST', 'saveCustomerSurvey', formObj, '', 'savingSurveyInfo'));
    }

    const steps = [
        {
            title: 'Client Information',
            content: <PatientInformation mainNext={next} form={form} />,
        },
        {
            title: 'Care Needs',
            content: <CareNeeds mainNext={next} Question={questionsList && questionsList.dailyLivingActivities} formData={formData} setFormData={setFormData} />,
        },
        {
            title: 'Health Conditions',
            content: <HealthCondition mainNext={next} Question={questionsList && questionsList.healthCondition} />,
        },
        {
            title: 'Information',
            content: <Information mainNext={completed} savingFirstSurvey={savingFirstSurvey} />,
        },
    ];

    if (surveySaveError) {
        message.error("Some Error Occur While Saving Info.")
        dispatch({
            type: 'reset_survey'
        })
    }

    if (surveySaveSuccess) {
        message.success("your information store successfully")
        dispatch({
            type: 'question-multistep-modal'
        })
        dispatch({
            type: 'thanks_modal_completion_of_survey'
        })
        dispatch({
            type: 'reset_survey'
        })
        // history.push('/client/dashboard')


    }
    return (
        <>
            <SimpleModal
                title="Questionnaire"
                modalFor="question-multistep-modal"
                visible={multiStepModelVisible}
                width={630}
                closable={true}
                className="multiStep-modal"
                style={{ top: 20 }}
                maskClosable={false}
            >

                <>
                    <Steps current={current} size="small" progressDot >
                        {steps.map(item => (
                            <Step key={item.title} title={item.title} />
                        ))}
                    </Steps>
                    <div className="steps-content">{steps[current].content}</div>
                    {/* <div className="steps-action">
                        {current < steps.length - 1 && (
                            <Button className="gx-pt-0 gx-mb-0" type="primary" onClick={() => next()}>
                                Next
                            </Button>
                        )}
                        {current === steps.length - 1 && (
                            <Button className="gx-pt-0 gx-mb-0" type="primary" onClick={() => message.success('Processing complete!')}>
                                Done
                            </Button>
                        )}
                        {current > 0 && (
                            <Button className="gx-pt-0 gx-mb-0" style={{ margin: '0 8px' }} onClick={() => prev()}>
                                Previous
                            </Button>
                        )}
                    </div> */}
                </>


            </SimpleModal>
        </>
    )
}

export default Index
